export const ALL_PAST_VISIT = 'all-past-visit';
